import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { PreferredStatusMappingSubmitMode } from 'components/ProviderData/IpaAdministration/atoms/Models';

const preferredStatusFormSubject = new Subject<PreferredStatusMappingSubmitMode>();
const preferredStatusGridRefreshSubject = new Subject<number>();

const IpaPreferredStatusService = {
    submit: (mode: PreferredStatusMappingSubmitMode) => preferredStatusFormSubject.next(mode),
    submit$: (): Observable<PreferredStatusMappingSubmitMode> => preferredStatusFormSubject.asObservable(),

    refreshGrid: (ipaId: number) => {
        preferredStatusGridRefreshSubject.next(ipaId);
    },
    refreshGrid$: (ipaId: number): Observable<number> =>
        preferredStatusGridRefreshSubject.pipe(filter((id) => id === ipaId)),
};

export { IpaPreferredStatusService };
